import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'

import { shortDateTime } from 'helpers/formatters'
import Spinner from 'components/Spinner'

const HEHMQuantityBox = ({
  hehmQuantity,
  hehmAccountUpdatedAt,
  isHehmQuantityLoaded
}: {
  hehmQuantity: number | undefined,
  hehmAccountUpdatedAt: string | undefined
  isHehmQuantityLoaded: boolean
}) => {
  if (!isHehmQuantityLoaded) {
    return <Spinner variant="cell" />
  }

  return (
    <S.Container>
      <S.QuantityLabel>Active subscriptions</S.QuantityLabel>
      <S.QuantityRow>
        <S.QuantityText>{hehmQuantity ?? 0}</S.QuantityText>
        <S.LastUpdated>Last Updated at: {shortDateTime(hehmAccountUpdatedAt)}</S.LastUpdated>
      </S.QuantityRow>
    </S.Container>
  )
}

export default HEHMQuantityBox

const S = {
  QuantityLabel: styled.div`
    font-size: 10px;
    color: ${color('premiumText')};
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    margin-top: 16px;
  `,
  QuantityRow: styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 10px;
  `,
  QuantityText: styled.span`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 8px;
    padding: 6px;
    width: fit-content;
    background-color: ${color('hehmQuantityBoxBackground')};
    font-size: 16px;
    font-weight: 600;
    color: ${color('hehmQuantityText')};
  `,
  LastUpdated: styled.i`
    margin-top: 4px;
    font-size: 12px;
    color: ${color('premiumText')};
  `
}
